import { parseErrors, parseValids } from '../utils/batch';

const initialState = {
  tab: 'leads',
  ready: true,
  dragging: false,
  results: [],
  leadsData: '',
  leadsFile: '',
  error: false,
  status: '',
  apiStatus: '',
  history: [],
  resultsHistory: [],
  previewing: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_PREVIEW_MODE':
      return { ...initialState, tab: state.tab, previewing: !state.previewing };
    case 'LOAD_BATCH_HISTORY':
      return { ...state, history: action.history };
    case 'LOAD_RESULTS_HISTORY':
      return { ...state, resultsHistory: action.results };
    case 'OPEN_DROPZONE':
      return { ...state, dragging: true };
    case 'CLOSE_DROPZONE':
      return { ...state, dragging: false };
    case 'UPLOAD_READY':
      return { ...state, ready: true, error: false };
    case 'UPLOAD_BUSY':
      return { ...state, ready: false, error: false };
    case 'LOAD_BATCH_RESULTS': {
      let response;
      let results;
      switch (action.status) {
        case 'error':
          response = action;
          results = parseErrors(response.errors || []);
          break;
        case 'processed':
          response = action.diff;
          results = parseValids(response.diff || []);
          break;
        case 'valid':
        default:
          response = action;
          results = parseValids(response.diff || []);
          break;
      }

      return {
        ...response,
        ...state,
        ready: true,
        error: false,
        apiStatus: action.status,
        results,
        leadsData: '',
        leadsFile: '',
      };
    }
    case 'SET_LEADS_UPLOAD_STATUS':
      return {
        ...state,
        ready: false,
        error: false,
        leadsData: action.data,
      };
    case 'CLEAR_BATCH_RESULTS':
      return { ...initialState, tab: state.tab };
    case 'CLEAR_BATCH_RESULTS_SAVE_MODE':
      return { ...initialState, previewing: state.previewing, tab: state.tab };
    case 'CLEAR_BATCH_ERROR':
      return { ...state, ready: true, error: false };
    case 'SET_BATCH_ERROR':
      return { ...state, ready: true, error: action.error };
    case 'SET_UPLOAD_STATUS':
      return { ...state, status: action.status };
    case 'CHANGE_BATCH_TAB':
      return { ...initialState, tab: action.tab };
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
